import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "default-form" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wr" }
const _hoisted_5 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_6 = { class: "input-wr" }
const _hoisted_7 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-wr" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "input-wr dropdown" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_19 = {
  key: 0,
  class: "builder-or-partner-wr"
}
const _hoisted_20 = { class: "input-row section-row first-row" }
const _hoisted_21 = { class: "input-wr" }
const _hoisted_22 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_23 = { class: "input-wr" }
const _hoisted_24 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_25 = { class: "input-row" }
const _hoisted_26 = { class: "input-wr" }
const _hoisted_27 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_28 = { class: "input-wr" }
const _hoisted_29 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_30 = { class: "input-row" }
const _hoisted_31 = { class: "input-wr" }
const _hoisted_32 = {
  key: 0,
  class: "error-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "section-title" }, "Purchaser Details", -1)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
            type: "text",
            placeholder: "First Name"
          }, null, 512), [
            [_vModelText, $setup.form.firstName]
          ]),
          ($setup.v$.firstName.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
            type: "text",
            placeholder: "Last Name"
          }, null, 512), [
            [_vModelText, $setup.form.lastName]
          ]),
          ($setup.v$.lastName.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.v$.lastName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.email) = $event)),
            type: "text",
            placeholder: "Email"
          }, null, 512), [
            [_vModelText, $setup.form.email]
          ]),
          ($setup.v$.email.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
          _createVNode($setup["Cleave"], {
            class: "input input-large",
            modelValue: $setup.form.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phone) = $event)),
            options: $setup.phoneNumberOption($setup.form.phone),
            placeholder: "0412 345 678"
          }, null, 8, ["modelValue", "options"]),
          ($setup.v$.phone.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.postcode) = $event)),
            type: "text",
            placeholder: "e.g. 2000"
          }, null, 512), [
            [_vModelText, $setup.form.postcode]
          ]),
          ($setup.v$.postcode.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.postcode.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label" }, "Owner-occupier / Investor", -1)),
          _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
            control: _withCtx(() => [
              _createElementVNode("label", {
                class: _normalizeClass(["dropdown-button input-dropdown", { selected: $setup.form.holderType }]),
                type: "button"
              }, _toDisplayString($setup.form.holderType || "Select"), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$setup.HolderType.INVESTOR, $setup.HolderType.OWNER_OCCUPIER], (holder) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: holder,
                    onClick: ($event: any) => ($setup.form.holderType = holder),
                    class: _normalizeClass({ 'dropdown__item-active': holder === $setup.form.holderType })
                  }, _toDisplayString(holder), 11, _hoisted_17))
                }), 128))
              ])
            ]),
            _: 1
          }),
          ($setup.v$.holderType.$error && $setup.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.v$.holderType.$errors[0]?.$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_Transition, { name: "fade-default" }, {
        default: _withCtx(() => [
          ($setup.props.isBuilderOrChannelPartnerAdded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "section-title" }, "Builder / Channel Partner details", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.builderOrPartnerFirstName) = $event)),
                      type: "text",
                      placeholder: "First Name"
                    }, null, 512), [
                      [_vModelText, $setup.form.builderOrPartnerFirstName]
                    ]),
                    ($setup.v$.builderOrPartnerFirstName.$error && $setup.showErrors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.v$.builderOrPartnerFirstName.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.builderOrPartnerLastName) = $event)),
                      type: "text",
                      placeholder: "Last Name"
                    }, null, 512), [
                      [_vModelText, $setup.form.builderOrPartnerLastName]
                    ]),
                    ($setup.v$.builderOrPartnerLastName.$error && $setup.showErrors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.v$.builderOrPartnerLastName.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.builderOrPartnerEmail) = $event)),
                      type: "text",
                      placeholder: "example@gmail.com"
                    }, null, 512), [
                      [_vModelText, $setup.form.builderOrPartnerEmail]
                    ]),
                    ($setup.v$.builderOrPartnerEmail.$error && $setup.showErrors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($setup.v$.builderOrPartnerEmail.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                    _createVNode($setup["Cleave"], {
                      class: "input input-large",
                      modelValue: $setup.form.builderOrPartnerPhone,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.builderOrPartnerPhone) = $event)),
                      options: $setup.phoneNumberOption($setup.form.phone),
                      placeholder: "0412 345 678"
                    }, null, 8, ["modelValue", "options"]),
                    ($setup.v$.builderOrPartnerPhone.$error && $setup.showErrors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.v$.builderOrPartnerPhone.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "Company", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.builderOrPartnerCompany) = $event)),
                      type: "text",
                      placeholder: "Company"
                    }, null, 512), [
                      [_vModelText, $setup.form.builderOrPartnerCompany]
                    ]),
                    ($setup.v$.builderOrPartnerCompany.$error && $setup.showErrors)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.v$.builderOrPartnerCompany.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}